import React, {useState} from 'react';
import {useDispatch} from 'react-redux';

import {labels} from '../../../../util/utils';
import {projectStatusEnum} from '../../../../util/uiconstants';

import {removeProject} from '../../../../actions/Project/projectAction';

import ProjectConfirmationModal from '../ProjectConfirmationModal';

const RemoveModal = ({show, setShow, projectId, name, status}) => {
	const [isLoading, setIsLoading] = useState(false);

	const dispatch = useDispatch();

	const onHide = () => setShow(false);

	const onConfirm = () => {
		if (status !== projectStatusEnum.COMPLETED) {
			setIsLoading(true);
			dispatch(removeProject(projectId))
				.then(() => {
					setIsLoading(false);
					onHide();
				})
				.catch(() => setIsLoading(false));
		}
	};

	const props = {
		show,
		onHide,
		onConfirm,
		isLoading,
		title: labels.removeProject,
		confirmLabel: labels.confirm,
		instructional: labels.removeProjectInstructionalText,
		projectName: name || ''
	};

	return <ProjectConfirmationModal {...props} />;
};

RemoveModal.propTypes = {};

RemoveModal.defaultProps = {};

export default RemoveModal;
